export const formatNumber = (real: number) => real.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');